<template >
    <div>
		<!-- <sice-provider :mock-data="{ isApp: true, isLogin: false, openLog: true}"> -->
        <div id="top"></div>

        <!-- header -->
        <header-area :active-number="3"></header-area>

        <!-- main -->
        <article class="main">

            <div class="container">
                <h1 class="tit-type1" title="Fund Talks 揪團聽講座">
                    <span class="focus">
                        Fund Talks 揪團聽講座
                    </span>
                </h1>
                <section class="item blockStyle" ref="sectionItem">
                    <div class="item2">
                        <p>
                            想學基金理財？想了解最新投資趨勢？不論三五好友、社團同學、社區大學、鄉親里民、還是公司行號或人資福委，只要有理財上的需求，我們就來講給你聽！歡迎5人以上成團預約基金理財講座，主題由你選、地點由你訂、日期由你挑，富蘭克林資深顧問親自主講，讓我們用豐富經驗提供您專業建議，更重要的是…這一切諮詢服務都是『免費』，歡迎留下感興趣的理財話題，我們將盡快為您安排。
                        </p>
                        <el-alert
                            title="提醒您，敬請以單位名義來報名，目前暫不開放個人預約。"
                            type="warning"
                            :closable="false"
                            show-icon>
                        </el-alert>
                        <!-- <p>
                            <b class="tit-type2">講座主題與內容</b>
                        </p> -->
                        <el-table
                            :data="seminarData"
                            :style="{width: itemWidth + 'px'}"
                        >
                            <el-table-column
                                prop="theme"
                                label="講座主題"
                            >
                                <template v-slot="{ row }">
                                    <b class="focusText">{{row.theme}}</b>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="frequency"
                                label="預約"
                                width="160"
                            >
                                <template v-slot="{ row }">
                                    <el-button
                                        @click.native.prevent="toForm(row)"
                                        round
                                    >
                                        我要預約
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-divider><i class="el-icon-more"></i></el-divider>
                    <div class="item2 lastItem">
                        <h2 class="tit-type2" title="報名注意事項：">
                            報名注意事項：
                        </h2>
                        <ol>
                            <li>
                                僅限5人成團預約，個人欲參加講座請至 <el-link href="https://www.franklin.com.tw/Seminar/Index" type="primary" target="_blank">講座報名單元</el-link> 查詢最新活動消息。
                            </li>
                            <li>
                                每天開放三個時段預約，每個時段各一場。
                            </li>
                            <li>
                                可預約七個工作天後的上課時間。
                            </li>
                            <li>
                                預約後如需變更上課日期等資訊，請洽0800-885-888轉接專人為您服務。
                            </li>
                        </ol>
                    </div>
                </section>
            </div>

        </article>

        <!-- footer -->
        <footer-area></footer-area>

        <!-- <modal ref="warning" :can-close="false" class="md">
            <slot slot="infoArea">
                xxxx
            </slot>
        </modal> -->
    </div>
</template>

<script>
import HeaderArea from "@/components/HeaderArea.vue";
import FooterArea from "@/components/FooterArea.vue";

export default {
    components: {
        HeaderArea,
        FooterArea
    },
    data() {
        return {
            rawSeminarData: [
                {
                    theme: '坐下聊投資，您的需求我來聽',
                },
                {
                    theme: '定期定額投資理財術',
                },
                {
                    theme: '領息存基金投資術',
                },
                {
                    theme: '上班族理財規劃',
                },
                {
                    theme: '退休理財規劃',
                },
                {
                    theme: '子女教育金規劃',
                },
                {
                    theme: '家庭理財規劃',
                },
                {
                    theme: '購屋頭期款規劃',
                },
                {
                    theme: '最新股債市投資展望',
                },
                {
                    theme: '智能投資理財',
                },
                {
                    theme: '年終理財規劃',
                },
                {
                    theme: '自訂主題',
                    isCustom: true
                }
            ],
            itemWidth: 0
        }
    },
    methods: {
        toForm(data) {
            let seminarTitle = { theme: data.theme, isCustom: data.isCustom || false };
            localStorage.setItem("seminarTitle", JSON.stringify(seminarTitle)); //save in locale storage
            //前往表單
            this.$router.push({ name: "registrationForm", params: {id: data.id, title: data.theme, isCustom: data.isCustom} })
        },
        //調整element ui 在 IE11上無法解釋 "width: 100%" 的問題
        itemSectionRender() {
            this.itemWidth = this.$refs['sectionItem'].clientWidth;
        }
    },
    computed: {
        seminarData() {
            return this.rawSeminarData.map((item, index) => {
                item.id = index + 1;
                return item;
            })
        }
    },
    mounted() {
        this.itemSectionRender();
        this.toForm({
                    theme: '坐下聊投資，您的需求我來聽',
                    id: '1'
                });
    },
}
</script>